import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import { library } from '@fortawesome/fontawesome-svg-core'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {
  faX,
  faUser,
  faUserPlus,
  faTrashCan,
  faArrowUpFromBracket,
  faFolderClosed,
  faHome,
  faCheckDouble,
  faArrowLeft,
  faArrowsRotate,
  faEllipsisVertical,
  faFile,
  faFileLines,
  faFilePdf,
  faFileUpload,
  faFolder,
  faFolderTree,
  faImage,
  faPlus,
  faQuestionCircle,
  faTable,
  faTableCells,
  faFileWord,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileVideo,
  faFileAudio,
  faFileZipper,
  faTrash,
  faPencil,
  faUsersBetweenLines,
  faClock,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import authStore from '@/services/authStore'
import helpers from '@/helpers'
import { abilitiesPlugin } from '@casl/vue'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import ability from './libs/acl/ability'

Vue.use(abilitiesPlugin, ability)

// fontawesome icons that i use in the project
library.add(
  faX,
  faUser,
  faUserPlus,
  faTrashCan,
  faArrowUpFromBracket,
  faFolderClosed,
  faHome,
  faCheckDouble,
  faFileLines,
  faArrowsRotate,
  faQuestionCircle,
  faFolder,
  faFolderTree,
  faFilePdf,
  faFile,
  faTable,
  faTableCells,
  faEllipsisVertical,
  faArrowLeft,
  faPlus,
  faFileUpload,
  faImage,
  faFileWord,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileVideo,
  faFileAudio,
  faFileZipper,
  faTrash,
  faPencil,
  faUsersBetweenLines,
  faClock,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// BUS
Vue.prototype.$eventBus = new Vue()

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('ucfirst', value => {
  if (!value) return ''
  // eslint-disable-next-line no-param-reassign
  value = value.toString()
  return value.charAt(0)
    .toUpperCase() + value.slice(1)
})

/** Vue Filters Start */
Vue.filter('truncate', (text, length, suffix) => {
  if (text.length > length) {
    return text.substring(0, length) + suffix
  }
  return text
})

router.beforeEach((to, from, next) => {
  // if (!canNavigate && to.meta.requiresAuth && authStore().isAuthenticated.value) {
  //   next('/forbidden')
  // } else
  if (to.meta.requiresAuth && !authStore().isAuthenticated.value) {
    // console.log('login1');
    next('/login')
  } else if (!to.meta.requiresAuth && authStore().isAuthenticated.value) {
    // console.log('logout1');
    store.dispatch('auth/logout')
    next('/login')
  } else {
    const canNavigate = to.matched.some(route => {
      ability.can(route.meta.action || 'read', route.meta.resource)
    })

    console.log('cannavigate', canNavigate)
    // console.log('next');
    next()
  }
})

Vue.use(helpers)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
